import { ManagerType } from 'src/models/employerManagers.types';
import { ManagersList } from 'src/models/employerManagersPage';

export const getIsManagerMCP = (manager: ManagersList): boolean =>
    manager.type === ManagerType.Mcp || manager.managerType === ManagerType.McpGroup;
